import React from "react";
import { LoadioConfigurationMasterPasswordEditTemplate } from "themes/administration/loadio/components";

class LoadioConfigurationMasterPasswordEdit extends React.Component {
    render() {
        return <LoadioConfigurationMasterPasswordEditTemplate {...this.props} />;
    }
}

export default LoadioConfigurationMasterPasswordEdit;
